import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to think about problems laterally.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>A boy was walking down the road, and came to a place where
                                                the road divided in two; each road
                                                went in a different direction. There was a girl standing at
                                                the fork in the road. The boy knew that
                                                one road led to Lieville, a town where everyone always lied,
                                                and the other led to Trueville, a town
                                                where everyone always told the truth. He also knew that the
                                                girl came from one of those towns,
                                                but he didn’t know which one.</p>
                                            <p><span className="subtiltereg">What should the boy ask the girl to find out the way to Trueville?</span>
                                            </p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter ">
                                                <div className="border_subtitle">Are you in or outside the
                                                    box?
                                                </div>
                                                <p>In 1967, Edward DeBono<a className="superscripttext"
                                                                            href="further_info.php?course=300"><sup>1</sup></a> coined
                                                    the concept of ‘lateral thinking’ – a way of
                                                    understanding
                                                    concepts and rules but not being restrained by them.
                                                    Albert Einstein, for example, understood
                                                    classical mechanics but was still able to think
                                                    laterally about issues without being constrained
                                                    by these mechanics. The goal of using lateral thinking,
                                                    therefore, is to shift away from thinking
                                                    in an orthodox way to being more innovative in your
                                                    solutions. Innovation can help you think
                                                    about issues more broadly, and in ways you may have
                                                    previously overlooked.</p>
                                                <div className="border_subtitle">The truth and nothing but
                                                    the truth
                                                </div>
                                                <div className="uiheading"><p>So let’s revisit the lateral
                                                    thinking problem that we gave you at the beginning of
                                                    the page. With the
                                                    above problem you need to ask the question, ‘Which way
                                                    is your town?’, because the girl was from
                                                    Lieville, she would point to Trueville because she has
                                                    to lie; if she was from Trueville, she’ll point
                                                    to Trueville because she has to tell the truth. So
                                                    whatever road the girl points to will be the road
                                                    to Trueville. Did you get it? Well, even if you didn’t,
                                                    lateral thinking can be learnt and trained.</p></div>
                                            </div>
                                            <br/>


                                            <div className="border_subtitle">This tool can help</div>
                                            <p>The important factor here is that we all see things
                                                differently and at work we need to capitalise
                                                on these differences fully to be most effective. This
                                                tool is about <span className="green brownbold">how to think about problems
laterally </span>and will help you to understand different thinking styles and preferences. Increasing
                                                your awareness of personal styles and preferences can
                                                help you to see situations from different
                                                perspectives to your normal approach.</p>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}